module.exports = __webpack_public_path__ + "img/centered-logo-nav-hyundai.f3414755.png";